<template>
  <div class="rank-manager">
    <div class="top">
      <el-radio-group v-model="type" @change="changeType">
        <el-radio-button label="examination">升國中</el-radio-button>
        <el-radio-button label="special-class">升高中</el-radio-button>
        <el-radio-button label="university">升大學</el-radio-button>
      </el-radio-group>
      <div class="year-input">
        <div class="label">年份</div>
        <el-select
          v-model="year"
          placeholder="選擇年份"
          no-data-text="無資料"
          @change="changeYear"
        >
          <el-option
            v-for="item in yearOptions"
            :key="item.value"
            :label="item.title"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <el-button type="success" @click="createRank">新增榜單</el-button>
    </div>
    <el-table
      :data="ranksData.list"
      border
      stripe
      empty-text="沒有資料"
      style="width: 100%"
    >
      <el-table-column prop="type" label="類別" width="180">
        <template slot-scope="{ row }">
          <div>{{ typeName(row.type) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="year" label="年份" width="180"> </el-table-column>
      <el-table-column prop="title" label="標題" width="300"> </el-table-column>

      <el-table-column label="修改" width="100">
        <template slot-scope="{ row }">
          <div class="center">
            <el-button type="warning" @click="editRank(row)">修改</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="刪除" width="100">
        <template slot-scope="{ row }">
          <div class="center">
            <el-button type="danger" @click="remove(row.id)">刪除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="size"
      :total="ranksData.total"
      :current-page.sync="currentPage"
      @current-change="pageChange"
    >
    </el-pagination>
    <RankEditor
      :rankEditorVisible.sync="rankEditorVisible"
      :rankForm="rankForm"
      :isCreate="isCreate"
      @saveRank="saveRank"
    >
    </RankEditor>
  </div>
</template>

<script>
import Api from '@/api/MaganmentApi';
import _ from 'lodash';
import Swal from 'sweetalert2';
import RankEditor from '@/components/management/RankEditor';
import moment from 'moment';

export default {
  data() {
    return {
      size: 20,
      currentPage: 1,
      type: 'examination',
      year: '',
      rankEditorVisible: false,
      rankForm: {
        type: '',
        year: '',
        title: '',
        names: [{ value: '', key: Date.now() }],
      },
      isCreate: false,
      ranksData: {
        list: [],
        total: 0,
      },
    };
  },
  computed: {
    yearOptions() {
      let nowYear = moment().format('YYYY');
      const countryYear = Number(nowYear) - 1911;
      let list = [{ title: '全部', value: '' }];
      for (let i = countryYear; i >= 105; i--) {
        const item = {
          title: i,
          value: i,
        };
        list.push(item);
      }
      return list;
    },
  },
  methods: {
    replaceQuery() {
      let newQuery = {
        type: this.type,
        year: this.year,
        page: this.currentPage,
      };
      this.$router.replace({ query: newQuery });
    },
    changeType() {
      this.replaceQuery();
      this.search();
    },
    changeYear() {
      this.replaceQuery();
      this.search();
    },
    pageChange() {
      this.replaceQuery();
      this.search();
    },
    createRank() {
      this.isCreate = true;
      this.ranksData = {
        list: [],
        total: 0,
      };
      this.rankEditorVisible = true;
    },
    editRank(data) {
      let tmpList = [];
      let i = 0;
      for (let name of data.names) {
        tmpList.push({
          value: name,
          key: Date.now() + i,
        });
        i++;
      }
      let tmpData = _.cloneDeep(data);
      tmpData.names = _.cloneDeep(tmpList);
      this.isCreate = false;
      this.rankForm = tmpData;
      this.rankEditorVisible = true;
    },
    async remove(id) {
      Swal.fire({
        title: '確定刪除？',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: '取消',
        confirmButtonText: '確定',
      }).then(async (result) => {
        if (result.value) {
          try {
            await Api.removeRank(id);
            _.remove(this.ranksData.list, (rank) => {
              return rank.id == id;
            });
            this.$set(this.ranksData.list, this.ranksData.list);
            this.$message({
              message: '刪除成功',
              type: 'success',
            });
          } catch (e) {
            Swal.fire({
              title: 'Error!',
              text: '發生錯誤，請檢查網路或聯絡管理人員',
              icon: 'error',
            });
            window.console.log(e);
          }
        }
      });
    },
    async saveRank(rankForm) {
      let rankData = _.cloneDeep(rankForm);
      let tempList = [];
      for (let name of rankData.names) {
        tempList.push(name.value);
      }
      rankData.names = tempList;
      try {
        if (this.isCreate) {
          await Api.createRank(rankData);
          this.init();
          this.rankEditorVisible = false;
          this.$message({
            message: '新增成功',
            type: 'success',
          });
        } else {
          await Api.updateRank(rankData);
          this.init();
          this.rankEditorVisible = false;
          this.$message({
            message: '修改成功',
            type: 'success',
          });
        }
      } catch (e) {
        Swal.fire({
          title: 'Error!',
          text: '發生錯誤，請檢查網路或聯絡管理人員',
          icon: 'error',
        });
        window.console.log(e);
      }
    },
    async search() {
      const query = {
        type: this.type,
        year: this.year,
        page: this.currentPage,
        size: this.size,
      };
      const res = await Api.getRankList(query);
      this.ranksData = res.data;
    },
    typeName(type) {
      switch (type) {
        case 'examination':
          return '升國中';
        case 'special-class':
          return '升高中';
        case 'university':
          return '升大學';
        default:
          break;
      }
    },
    init() {
      this.currentPage = this.$route.query.page
        ? parseInt(this.$route.query.page)
        : 1;
      this.type = this.$route.query.type
        ? this.$route.query.type
        : 'examination';
      this.year = this.$route.query.year ? this.$route.query.year : '';
      this.search();
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  components: {
    RankEditor,
  },
};
</script>

<style lang="scss" scoped>
.rank-manager {
  .top {
    margin-bottom: 15px;
    display: flex;
    align-items: center;

    .year-input {
      margin-right: 30px;
      display: flex;
      align-items: center;

      .label {
        flex-shrink: 0;
        margin-right: 3px;
      }

      .el-input {
        width: 230px;
        margin-right: 5px;
      }
    }

    .el-radio-group {
      margin-right: 20px;
    }
  }
}
</style>
